import axios from "axios";

export const api = axios.create({
  baseURL: window.env.REACT_APP_LINK_API,
  headers: {
    "Content-Type": "application/json",
  },
});
